
<!--
  - Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  - This source code, and resulting software, is the confidential and proprietary information
  - ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  - of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  - and shall use it only in accordance with the terms and conditions of any and all license
  - agreements you have entered into with The Company.
  -->

<template>
  <Users v-if="$route.matched.length === 1"/>
  <router-view v-else/>
</template>

<script>
import Users from "@/views/Account/Users";
export default {
  name: "Team",
  components: {Users}
}
</script>

<style scoped>

</style>
